import { Injectable } from '@angular/core';
import { SubscriptionService } from '../../services/subscription/subscription.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionBusinessService {

  constructor(private subscriptionService: SubscriptionService) { }

  createCard(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.createCard(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
            observer.complete();
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }

  createSubscription(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.createSubscription(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  updateAutoRenewal(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.updateAutoRenewal(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  subscribeTrial(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.subscribeTrial(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  getPlanById(paramsReq):Observable<any>{
    return new Observable((observer) => {
      this.subscriptionService.getPlanById(paramsReq).subscribe({
        next: (response) => {
          try {
            observer.next(response)
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  updateBillingAddress(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.updateBillingAddress(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  zipCodeValidation(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.zipCodeValidation(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  createMultipleLocation(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.createMultipleLocation(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
            observer.complete();
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }

  createMultipleStylist(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.createMultipleStylist(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
            observer.complete();
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }

  promoCodeValidation(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.promoCodeValidation(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }

  storeRpDetails(data: any): Observable<any> {
    return new Observable((observer) => {
      this.subscriptionService.storeRpDetails(data).subscribe({
        next: (response) => {
          try {
            observer.next(response);
          }
          catch (e) {
            observer.error(e);
          }
        },
        error: (error) => {
          observer.error(error);
        }
      })
    })
  }
}
